import React from 'react';
import { getActiveEntityId, getActiveUserId } from 'app/actions/AuthedActions';
import Banner from 'app/components/Banner';
import FooterLinks from 'app/components/FooterLinks';
// import OTPForm from './OTPForm';
import Spinner from '../Spinner';
import SideBar from '../SideBar';
import StyledLogin from './styled';

class OTP extends React.Component {
    componentDidMount() {
        const otpStatus = localStorage.getItem('sendOTP');
        if (otpStatus) {
            if (process.env.REACT_APP_ENV !== 'development') {
                this.generateOtp();
            }
            localStorage.removeItem('sendOTP');
        }
    }

    generateOtp = () => {
        const { generateMfaOtp, logout } = this.props;
        const userId = getActiveUserId();
        if (userId) {
            generateMfaOtp(userId);
        } else {
            logout();
        }
    };

    handleOtpAuth = (d, from) => {
        const { mfaOtpAuth } = this.props;
        const entityId = getActiveEntityId();
        const userId = getActiveUserId();
        if (entityId && userId) {
            return mfaOtpAuth(userId, { otp: d }, from);
        }
        return null;
    };

    render() {
        const { errorMsg } = this.props;
        const { hash } = this.props.location;
        if (hash && !errorMsg) {
            return <Spinner />;
        }

        return (
            <>
                <StyledLogin>
                    <div className="container">
                        <div className="row">
                            <div className="span6">
                                <SideBar />
                            </div>
                            <div className="span6">
                                {/* <OTPForm {...this.props} onSubmit={this.handleOtpAuth} onResendOtp={this.generateOtp} /> */}
                            </div>
                        </div>
                        <div className="white-bg" />
                        <Banner />
                    </div>
                </StyledLogin>
                <FooterLinks />
            </>
        );
    }
}

export default OTP;
